import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import PostMessage from "./PostMessage";
import FormPostMessage from "./forms/FormPostMessage";

@inject('postMessageForm')
@observer
export default class PostMessageList extends React.Component {    

    @observable showAll = false;

    static defaultProps = {
        block: 'post-message-summary',
        items: [],
        max: 3,
        text: {
            more: 'Show All',
            less: 'Show Less',
            and: 'and',
            none: 'None',
            comma: ', '
        },        
        preventSingleRemaining: false,
    };


    handleShowOthers(event) {
        event.preventDefault();
        this.showAll = !this.showAll;
    }


    renderAddButton() {
        let { postMessageForm, post } = this.props;
        let formPostMessage = postMessageForm.display && postMessageForm.$('postid').value === post.id ? <FormPostMessage form={postMessageForm} postId={post.id} /> : "";
        return (
            <div>
                <div className="post-messages-button-add">
                    <span onClick={() => {
                        postMessageForm.display = true;
                        postMessageForm.$('postid').value = post.id;
                    }}>Add Update</span>
                </div>
                { formPostMessage }
            </div>
        );
    }

    deleteCallback(item) {
        let { items } = this.props;   
        let deletedIndex = items.indexOf(item);
        let deleteLastItem = deletedIndex === 0 && items.length === 1;
        if (deleteLastItem)
            items.pop(); // fix weird issue when the last item is not removed from this.props.items
    }

    itemRenderer(item) {
        let { isLoggedIn } = this.props;
        return (<PostMessage message={item} isLoggedIn={isLoggedIn} key={item.id} deleteCallback={this.deleteCallback.bind(this, item)} />)
    }

    render() {

        let { items, text, max, isLoggedIn, allowAddUpdate } = this.props;

        return (<div className="post-messages">
            {items.length > max && <div className="post-messages-more" onClick={this.handleShowOthers.bind(this)}><span>{items.length} Updates</span> | <span>{!this.showAll ? text.more : text.less}</span></div>}
            <div className="post-messages-list">
                {items.map((item, i) => {
                    return (this.showAll || i < max
                        ? <div key={i}>
                            {this.itemRenderer(item)}
                        </div>
                        : null);
                })}
            </div>
            {isLoggedIn && allowAddUpdate && this.renderAddButton()}
        </div>);

    }
}


// WEBPACK FOOTER //
// ./src/components/PostMessageList.jsx